import ApiClient from "@/api/ApiClient.ts";
import { NEW_NOTIFICATION } from "@/events/constants";
import { ENJOY_BCN_WG, NOTIFICATION_TYPE_STREET_ERRORS } from "@/utils/constants";
import qs from "qs";

const state = {
  streets: null,
  streetsView: [],
  selectedStreetView: null,
  streetToEdit: null,
  portalStreetToEdit: null,
  activeStepMapStreets: null,
};

const mutations = {
  setStreets(state, streets) {
    state.streets = streets;
  },

  setStreetsView(state, streets) {
    state.streetsView = streets;
  },

  setSelectedStreetView(state, street) {
    state.selectedStreetView = street;
  },

  setStreetToEdit(state, street) {
    state.streetToEdit = street;
  },

  setPortalStreetToEdit(state, portal) {
    state.portalStreetToEdit = portal;
  },

  setActiveStepMapStreets(state, step) {
    state.activeStepMapStreets = step;
  },
};

const actions = {
  async getStreets({ commit }, paramsToSend) {
    const params = {
      ...paramsToSend,
    };
    try {
      const api = ApiClient();
      let response = await api.get("streets/streetsByText", { params });
      let streets = response.data.map((x) => {
        return {
          id: x.id,
          value: x.street,
          centralId: x.centralId,
          poi: x.poi,
          stopBelong: x.stopBelong,
        };
      });
      commit("setStreets", streets);
      return streets;
    } catch (error) {
      console.error("ERROR en getStreets: ", error.message);
    }
  },

  async getStreet({ commit }, paramsToSend) {
    const params = {
      ...paramsToSend,
    };
    try {
      const api = ApiClient();
      let response = await api.get("streets", { params });
      commit("setSelectedStreetView", response.data);
      commit("setStreetToEdit", response.data);
      return response.data;
    } catch (error) {
      console.error("ERROR en getStreets: ", error.message);
    }
  },

  async getStreetsView({ commit }, payload) {
    let params = {};
    if (payload) {
      params = {
        wgId: payload.params.wgId,
        centralId: payload.params.centralId,
      };
    }
    try {
      const api = ApiClient();
      let response = await api.get("streets/streetView", { params });
      commit("setStreetsView", response.data);
    } catch (error) {
      console.error("ERROR en getStreetsView: ", error.message);
    }
  },

  async getStreetsNearestPortal(_, paramsToSend) {
    const params = {
      ...paramsToSend,
    };
    try {
      const api = ApiClient();
      let response = await api.get("streets/nearestPortal", { params });
      return response.data;
    } catch (error) {
      console.error("ERROR en getStreetsNearestPortal: ", error.message);
    }
  },

  async getStreetsNearestPortal3(_, paramsToSend) {
    const params = {
      ...paramsToSend,
    };
    try {
      const api = ApiClient();
      let response = await api.get("streets/nearestPortal3", { params });
      return response.data;
    } catch (error) {
      console.error("ERROR en getStreetsNearestPortal3: ", error.message);
    }
  },

  async createStreet(_, payload) {
    const params = {
      wgId: payload.params.wgId,
      centralId: payload.params.centralId,
    };
    payload.data.centralId = payload.params.centralId;
    const urlFormData = qs.stringify({ values: JSON.stringify(payload.data) });
    try {
      const api = ApiClient();
      let response = await api.post("streets", urlFormData, {
        params,
        headers: { "content-type": "application/x-www-form-urlencoded" },
      });
      return response.data.id;
    } catch (error) {
      console.error("ERROR en createStreet: ", error.message);
      return false;
    }
  },

  async createPortalStreet(_, payload) {
    const params = {
      ...payload.params,
    };
    const urlFormData = qs.stringify({ values: JSON.stringify(payload.data) });
    try {
      const api = ApiClient();
      await api.post("streets/portal", urlFormData, {
        params,
        headers: { "content-type": "application/x-www-form-urlencoded" },
      });
      return true;
    } catch (error) {
      console.error("ERROR en createPortalStreet: ", error.message);
      return false;
    }
  },

  async updateStreet(_, payload) {
    const params = {
      ...payload.params,
    };
    const urlFormData = qs.stringify({ values: JSON.stringify(payload.data) });
    try {
      const api = ApiClient();
      await api.put("streets", urlFormData, {
        params,
        headers: { "content-type": "application/x-www-form-urlencoded" },
      });
      return true;
    } catch (error) {
      console.error("ERROR en updateStreet: ", error.message);
      return false;
    }
  },

  async updatePortalStreet(_, payload) {
    const params = {
      ...payload.params,
    };
    const urlFormData = qs.stringify({ values: JSON.stringify(payload.data) });
    try {
      const api = ApiClient();
      await api.put("streets/portal", urlFormData, {
        params,
        headers: { "content-type": "application/x-www-form-urlencoded" },
      });
      return true;
    } catch (error) {
      console.error("ERROR en updatePortalStreet: ", error.message);
      return false;
    }
  },

  async deleteStreet(_, payload) {
    const params = {
      ...payload.params,
    };

    try {
      await ApiClient().delete("streets", {
        params,
      });
      return true;
    } catch (error) {
      console.error("ERROR en deletePortalsStreet: ", error.response);
      return false;
    }
  },

  async deletePortalsStreet(_, payload) {
    const params = {
      ...payload.params,
    };

    try {
      const api = ApiClient();
      await api.delete("streets/portal", {
        params,
      });
      return true;
    } catch (error) {
      console.error("ERROR en deletePortalsStreet: ", error.response);
      return false;
    }
  },

  async checkStreetsErrors(_, workgroupIds) {
    let streetsErrorsCount = 0;
    for (let workgroupId of workgroupIds) {
      if (workgroupId === ENJOY_BCN_WG) continue;
      try {
        const streets = (await ApiClient().get(`/streets/streetsWithoutPortal?idWg=${workgroupId}`))
          .data;
        streetsErrorsCount += streets.length;
      } catch (e) {
        console.error("Could not check streets or portals for errors", e);
      }
    }
    if (streetsErrorsCount > 0) {
      window.$bus.emit(NEW_NOTIFICATION, {
        type: NOTIFICATION_TYPE_STREET_ERRORS,
        inserted: Date.now(),
      });
    }
  },
};

const getters = {
  streets(state) {
    return state.streets;
  },

  streetsView(state) {
    return state.streetsView;
  },

  selectedStreetView(state) {
    if (state.selectedStreetView) {
      return state.selectedStreetView;
    }
  },

  selectedStreetViewPortals(state) {
    let portalsCoords = [];
    if (state.selectedStreetView) {
      portalsCoords = state.selectedStreetView.portals.map((p) => {
        p.coords = p.coords.reverse();
        return p;
      });
    }
    return portalsCoords;
  },

  streetToEdit(state) {
    return state.streetToEdit;
  },

  portalStreetToEdit(state) {
    return state.portalStreetToEdit;
  },

  activeStepMapStreets(state) {
    return state.activeStepMapStreets;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
